import { render, staticRenderFns } from "./AutocompleteItem.vue?vue&type=template&id=39530dd5&"
import script from "./AutocompleteItem.vue?vue&type=script&lang=js&"
export * from "./AutocompleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports